<template>
    <v-container class="px-md-12">
        <v-row class="my-8">
            <v-col cols="12">
                <div class="display-3 text-center"
                     :style="{color: $vuetify.theme.themes.dark.primary}">
                    Sustainable Development Goals
                </div>
            </v-col>
        </v-row>
        <v-row class="mt-12">
            <v-col cols="12">
            <span class="headline"
            >The Agenda for Sustainable Development was first adopted by all United Nations Member States in 2015. With the 17 Sustainable Development Goals, the project proposes a blueprint for a peace and prosperous future for people and the planet.</span>
            </v-col>
        </v-row>
        <v-img max-width="1024px" class="my-8 justify-center" src="../assets/sdg_logos/overview.svg"></v-img>
        <v-row>
            <v-col cols="12">
            <span class="headline"
            >The Multimedia Cartography 2020 and 2021 courses at ETH Zurich aimed to support this UN directive: Students focused on one or more development goals, processed data and created maps combined with multimedia elements for the selected topics.</span>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        name: 'Background'
    }
</script>
<style>
    html {
        overflow-y: auto !important;
    }
</style>
<style scoped>
    .container {
        max-width: 1200px !important;
    }
</style>
